var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"visibleLittle":_vm.isHeader,"id":"header-scroll"}}),_c('Identity',{staticClass:"mt-0",attrs:{"id":"identity-scroll"}}),_c('PhotoSectionExtensible',{attrs:{"id":"photo-section-scroll"},on:{"showHeader":_vm.isVisibleHeader}}),_c('Contact',{attrs:{"id":"contact-scroll"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }